<template>
  <div class="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5 xl:gap-4">
    <div class="card">
      <transition name="slide-fade" mode="out-in">
        <h2
          :key="statistics.num_investments"
          class="text-made text-ontick-carbon-900 font-semibold dark:text-gray-100 md:text-2xl"
        >
          {{ visibility ? statistics.num_investments : "---" }}
        </h2>
      </transition>
      <p
        class="text-ontick-carbon-500 py-2 text-xs dark:text-gray-400 md:text-sm"
      >
        Investimentos
      </p>
    </div>
    <div class="card">
      <transition name="slide-fade" mode="out-in">
        <h2
          :key="statistics.num_positions"
          class="text-made text-ontick-carbon-900 font-semibold dark:text-gray-100 md:text-2xl"
        >
          {{ visibility ? statistics.num_positions : "---" }}
        </h2>
      </transition>
      <p
        class="text-ontick-carbon-500 py-2 text-xs dark:text-gray-400 md:text-sm"
      >
        Operações
      </p>
    </div>
    <!-- <div class="card">
      <transition name="slide-fade" mode="out-in">
        <h2
          :key="statistics.num_orders"
          class="text-made font-semibold text-ontick-carbon-900 dark:text-gray-100 md:text-2xl"
        >
          {{ visibility ? statistics.num_orders : "---" }}
        </h2>
      </transition>
      <p
        class="py-2 text-xs text-ontick-carbon-500 dark:text-gray-400 md:text-sm"
      >
        Ordens
      </p>
    </div> -->
    <div class="card">
      <transition name="slide-fade" mode="out-in">
        <h2
          :key="statistics.summed_contracts"
          class="text-made text-ontick-carbon-900 font-semibold dark:text-gray-100 md:text-2xl"
        >
          {{ visibility ? statistics.summed_contracts : "---" }}
        </h2>
      </transition>
      <p
        class="text-ontick-carbon-500 py-2 text-xs dark:text-gray-400 md:text-sm"
      >
        Minicontratos
      </p>
    </div>
    <div class="card">
      <transition name="slide-fade" mode="out-in">
        <h2
          :key="statistics.summed_stocks"
          class="text-made text-ontick-carbon-900 font-semibold dark:text-gray-100 md:text-2xl"
        >
          {{ visibility ? statistics.summed_stocks : "---" }}
        </h2>
      </transition>
      <p
        class="text-ontick-carbon-900 py-2 text-xs dark:text-gray-400 md:text-sm"
      >
        Ações
      </p>
    </div>

    <div class="card">
      <transition name="slide-fade" mode="out-in">
        <h2
          :key="statistics.win_ratio"
          class="text-made whitespace-nowrap font-semibold md:text-2xl"
          :class="
            statistics.win_ratio > 0 && visibility
              ? 'text-ontick-green-500'
              : statistics.win_ratio == 0 || !visibility
              ? '=  text-ontick-carbon-900 dark:text-gray-100'
              : 'text-ontick-red-500'
          "
        >
          {{ visibility ? statistics.win_ratio.toFixed(2) : "---" }} %
        </h2>
      </transition>
      <p
        class="text-ontick-carbon-900 whitespace-nowrap py-2 text-xs dark:text-gray-400 md:text-sm"
      >
        Taxa de acerto
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    statistics: { type: Object, default: {} },
    visibility: {
      type: Boolean,
    },
  },
  // methods: {
  //   hiddenValue(value) {
  //     if (this.visible) {
  //       return value;
  //     } else {
  //       return "---";
  //     }
  //   },
  // },
};
</script>

<style lang="scss" scoped>
.card {
  @apply dark:bg-ontick-graphite-500 flex flex-col items-center justify-center rounded-lg bg-gray-50 px-6 py-3 text-center md:py-6;
  box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.35);
}
</style>
